import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('integration')
  .add('integration.breadcrumb.api', { name: 'integration.api.general' });

  const v2 = default_dashboard
  .extend('integration')
  .add('integration.breadcrumb.api', { name: 'integration.api_v2.general' });

  const pages = [
  'general',
  'user',
  'sms',
  'get-state',
  'database',
  'group-database',
  'statistic',
  'phones'
];
const integration_breadcrumbs = pages.map(page => {
  return module
    .extend(`integration.api.${page}`)
    .add(`integration.breadcrumb.${page}`, { name: `integration.api.${page}` });
});

const pages_v2 = [
  'general',
  'sms',
  'get-state',
  'database',
  'group-database',
  'statistic',
  'phones'
];

const integration_breadcrumbs_v2 = pages_v2.map(page => {
  return v2
    .extend(`integration.api_v2.${page}`)
    .add(`integration.v2.breadcrumb.${page}`, { name: `integration.api_v2.${page}` });
});

export { integration_breadcrumbs, integration_breadcrumbs_v2 };
